// src/Actions/BackupLoginActions.js
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { jwtDecode } from "jwt-decode";

export const verifyBackupCode = (code) => async (dispatch) => {
  dispatch({ type: "BACKUP_CODE_VERIFY_LOADING" });

  try {
    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);
    const userGuid = decodedToken.userGuid;

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/verifyViaBackupCodeByUserId`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userGuid, code }),
      }
    );

    if (!response.ok) {
      throw new Error("Verification failed");
    }

    const data = await response.json();

    if (data.verifyCode) {
      dispatch({ type: "BACKUP_CODE_VERIFY_SUCCESS" });
    } else {
      dispatch({
        type: "BACKUP_CODE_VERIFY_ERROR",
        payload: "Backup code verification failed. Please try again.",
      });
    }
  } catch (error) {
    dispatch({
      type: "BACKUP_CODE_VERIFY_ERROR",
      payload: "An error occurred. Please try again.",
    });
  }
};

export const saveBackupRememberDevice = () => async (dispatch, getState) => {
  const rememberDeviceCheck = getState().rememberDevice.rememberDeviceCheck;
  if (!rememberDeviceCheck) return;

  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const deviceId = result.visitorId;

    const token = JSON.parse(localStorage.getItem("token"));
    const decodedToken = jwtDecode(token);
    const userGuid = decodedToken.userGuid;

    const body = {
      rememberDeviceCheck,
      deviceId,
      userGuid,
    };

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/addRememberDevice`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      }
    );

    if (response.ok) {
      dispatch({ type: "BACKUP_REMEMBER_DEVICE_SUCCESS" });
    }
  } catch (error) {
    //console.error("Error saving remembered device:", error);
  }
};

export const resetBackupLoginState = () => ({
  type: "BACKUP_LOGIN_RESET",
});
